import React from 'react'

const ButtonSearchGIF = () => {
  return (
    <button
      type="submit"
      className="search-button"
    >
      Search
    </button>
  )
}

export default React.memo(ButtonSearchGIF);
